import { FormRendererAPIType } from 'components/common/form/index';
import { useEffect, useState } from 'react';

export default function useWatchFormFieldsChanges(
    form: FormRendererAPIType,
    watchFields: Array<string>,
    flagField: string,
) {
    const [defaultState, setDefaultState] = useState({});
    const setDefaults = () => {
        setDefaultState(form.hookFormGetValues(watchFields));
    };
    const updateIndexFlag = form.hookFormWatch(flagField);
    useEffect(() => {
        if (!form.formDidMount) {
            return;
        }

        if (updateIndexFlag == '' || updateIndexFlag == undefined) {
            setDefaults();
            form.hookFormSetValue(flagField, 'N');
        }
    }, [form.formDidMount, updateIndexFlag]);

    const vList = form.hookFormWatch(watchFields);
    useEffect(() => {
        if (!Array.isArray(vList) || !Array.isArray(defaultState)) {
            return;
        }
        let same = true;
        for (let i = 0; i < vList.length; i++) {
            if (vList[i] != defaultState[i]) {
                same = false;
                break;
            }
        }
        form.hookFormSetValue(flagField, same ? 'N' : 'Y');
    }, [JSON.stringify(vList), JSON.stringify(defaultState)]);

    return setDefaults;
}
